var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FaqCategory',{attrs:{"faqCategory":_vm.faqCategory,"buttonLoading":_vm.buttonLoading},on:{"saveFaqCategory":_vm.saveFaqCategory}})}
var staticRenderFns = []

export { render, staticRenderFns }